import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 店铺搜索
export function getlistShop(data) {
  return axios.request({
    url: `${urlObj.crm}crm/tenant/search`,
    // http://192.168.99.14:5000/wss-order/afterSale/listShop
    method: 'post',
    data
  })
}
// 获取收货地址
// // 获取收货地址
// 需求变更 这个接口暂时不用
// export function getListAddress(params) {
//   return axios.request({
//     url: urlObj.wss + 'wss-order/address/listAddress',
//     method: 'get',
//     params
//   })
// }
export function getListAddress(params) {
  return axios.request({
    url: urlObj.crm + 'crm/resarea/gateway/city/inventory',
    method: 'get',
    params
  })
}

// 字典列获取支付状态
export function getDictionariesItems(params) {
  return axios.request({
    url: `${urlObj.crm}crm/dictionariesItem/dplx`,
    method: 'get',
    params
  })
}
